import { render, staticRenderFns } from "./AddressManualEntryForm.vue?vue&type=template&id=3b601320&"
import script from "./AddressManualEntryForm.vue?vue&type=script&lang=js&"
export * from "./AddressManualEntryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports